export class ApiUrls {
    public static readonly ConfigurationUrl: string = '/api/configuration';

    public static readonly MonitoringUrl: string = '/api/monitoring';
    public static readonly ServiceQueueStatisticsUrl: string = '/api/service/input-queue-statistics';
    public static readonly ServiceDownloadDeadlettersUrl: string = '/api/service/download-deadletters';
    public static readonly MessageStatisticsUrl: string = '/api/service/message-statistics';
    public static readonly ServiceDatesWithLogsUrl: string = '/api/service/logs-dates';
    public static readonly ServiceDownloadMessagesUrl: string = '/api/service/download-messages';
    public static readonly ServiceLogFilesUrl: string = '/api/service/log-files';
    public static readonly ServiceDownloadLogUrl: string = '/api/service/download-log';
    public static readonly ServiceDownloadLogGzUrl: string = '/api/service/download-log-gz';
    public static readonly ServiceDeleteLogFileUrl: string = '/api/service/log-file';
    public static readonly ServiceMessagesDatesUrl: string = '/api/service/messages-dates';
    public static readonly ServiceMessagesTagsUrl: string = '/api/service/message-tags';
    public static readonly ServiceMessagesLabelsUrl: string = '/api/service/message-labels';
    public static readonly ServiceQueueDeadlettersUrl: string = '/api/service/input-queue-deadletters';
    public static readonly SelfTestDatabaseUrl: string = '/api/selftest/database';
    public static readonly SelfTestJobsUrl: string = '/api/selftest/jobs';
    public static readonly ServiceRestartSchedulerUrl: string = '/api/service/restart-scheduler';
    public static readonly SelfTestAmadeusTestsUrl: string = '/api/selftest/amadeus-tests';
    public static readonly PingUrl: string = '/api/dev/ping';

    public static readonly AircraftsUrl: string = '/api/aircraft';
    public static readonly AircraftTypesUrl: string = '/api/aircraft/type';
    public static readonly AirportsUrl: string = '/api/airport';
    public static readonly MaintenancesUrl: string = '/api/aircraft/maintenance';
    public static readonly FlightsFullUrl: string = '/api/flight';
    public static readonly FlightBookableSegmentsUrl: string = '/api/flight/bookable-segments';
    public static readonly FlightDecodeUrl: string = '/api/flight/decode';
    public static readonly FlightMessageHistoryUrl: string = '/api/flight/messages';
    public static readonly FlightBuildBookableSegmentsUrl: string = '/api/flight/build-bookable-segments';

    public static readonly JobList: string = '/api/job/list';
    public static readonly JobByNameUrl: string = '/api/job/name';
    public static readonly JobStopUrl: string = '/api/job/stop';
    public static readonly JobStartUrl: string = '/api/job/start';
    public static readonly JobParametersUrl: string = '/api/job/parameters';
    public static readonly JobSettingsUrl: string = '/api/job/settings';
    public static readonly JobTriggerCreateUrl: string = '/api/job/create';
    public static readonly JobTriggerDeleteUrl: string = '/api/job/delete';
    public static readonly CheckTriggerNameUrl: string = '/api/job/check-trigger-name';
    public static readonly JobCronValidation: string = '/api/job/cron/validation';

    public static readonly PermissionUrl: string = '/api/permission';
    public static readonly PermissionRoleUrl: string = '/api/permission/role';
    public static readonly PrincipalUrl: string = '/api/permission/principals';

    public static readonly IrregUrl: string = '/api/irreg';
    public static readonly IrregSegmentTestUrl: string = '/api/irreg/segment-test';
    public static readonly IrregSegmentsUrl: string = '/api/irreg/segments';
    public static readonly IrregSearchUrl: string = '/api/irreg/search';
    public static readonly IrregSendUrl: string = '/api/irreg/send';
    public static readonly IrregReloadUrl: string = '/api/irreg/reload';
    public static readonly IrregPassengersUrl: string = '/api/irreg/passengers';
    public static readonly IrregExportUrl: string = '/api/irreg/export';
    public static readonly IrregLogsUrl: string = '/api/irreg/logs';
    public static readonly AmadeusLogUrl: string = '/api/irreg/amadeus-log';

    public static readonly PassengerUrl: string = '/api/passenger';
    public static readonly PassengerPnrBookingUrl: string = '/api/passenger/saved-booking'
    public static readonly PassengerPnrRemarksUrl: string = '/api/passenger/remarks'
    public static readonly PassengerLogsUrl: string = '/api/passenger/logs';
    public static readonly PassengerLoadUrl: string = '/api/passenger/load';
    public static readonly PassengerFileLoadUrl: string = '/api/passenger/file-load';

    public static readonly MasterDataAgencyUrl: string = '/api/masterdata/agency';
    public static readonly MasterDataAgenciesUrl: string = '/api/masterdata/agencies';
    public static readonly MasterDataUpsertAgenciesUrl: string = '/api/masterdata/upsert-agency';
    public static readonly MasterDataTaxConfigUrl: string = '/api/masterdata/tax-config';
    public static readonly MasterDataTaxConfigsUrl: string = '/api/masterdata/tax-configs';
    public static readonly MasterDataUpsertTaxConfigUrl: string = '/api/masterdata/upsert-tax-config';
    public static readonly MasterDataLogUrl: string = '/api/masterdata/log';
    public static readonly MasterDataBannersUrl: string = '/api/masterdata/banners';
    public static readonly MasterDataActualBannersUrl: string = '/api/masterdata/actual-banners';
    public static readonly MasterDataUpsertBannerUrl: string = '/api/masterdata/upsert-banner';

    public static readonly ValidationUrl: string = '/api/validation';
    public static readonly ValidationDetailsUrl: string = '/api/validation/details';
    public static readonly ValidationByRoomUrl: string = '/api/validation/validate';
    public static readonly ValidationCreateUrl: string = '/api/validation/create';
    public static readonly ValidationUpdateUrl: string = '/api/validation/update';
    public static readonly ValidationOptionsUrl: string = '/api/validation/property-options';

    public static readonly TemplatesManagement: string = '/api/templatesmanagement';
    public static readonly TemplatesManagementCodes = '/api/templatesmanagement/codes';

    public static readonly EmailsUrl = '/api/email';
    public static readonly EmailBodyUrl = '/api/email/body';
    public static readonly EmailAttachmentsUrl = '/api/email/attachments';
    public static readonly EmailAttachmentDownloadUrl = '/api/email/attachment';
    public static readonly EmailUpdateStatusUrl = '/api/email/update-status';

    public static readonly GuidelineUrl = '/api/guideline';
}
